import api from '@/api';

export async function loginUser(credentials) {
    try {
        const res = await api.post('/auth/login', credentials);
        return {
            user: res.data,
            error: null
        }
    } catch (err) {
        console.error('loginUser error:', err);
        // El backend responde 401 con un mensaje ya redactado y neutro ("Correo
        // o contraseña incorrectos"), igual exista el correo o no. Antes se
        // descartaba y se mostraba un texto genérico en inglés, así que el
        // usuario no distinguía un fallo de credenciales de uno del servidor.
        const status = err.response?.status;
        const fromServer = err.response?.data?.error;

        if (status === 400 || status === 401) {
            return { user: null, error: fromServer || 'Correo o contraseña incorrectos.' };
        }
        if (!err.response) {
            return { user: null, error: 'No se pudo contactar con el servidor. Revisa tu conexión.' };
        }
        return { user: null, error: 'No se pudo iniciar sesión. Inténtalo de nuevo más tarde.' };
    }
}

/**
 * Cierra la sesión en el servidor. La cookie es `httpOnly`, así que borrarla
 * es responsabilidad del backend (plan 27_09_2026 §4.4).
 */
export async function logoutUser() {
    try {
        await api.post('/auth/logout');
        return { success: true, error: null };
    } catch (err) {
        console.error('logoutUser error:', err);
        return { success: false, error: 'No se pudo cerrar la sesión.' };
    }
}

export async function requestPasswordReset(email) {
    try {
        const res = await api.post('/auth/forgot-password', { email });
        return {
            message: res.data?.message || 'Si el correo existe, recibirás un enlace de recuperación.',
            error: null,
        };
    } catch (err) {
        console.error('requestPasswordReset error:', err);
        return {
            message: null,
            error: 'No se pudo procesar la solicitud. Intenta de nuevo más tarde.',
        };
    }
}

export async function verifyResetToken(token) {
    try {
        const res = await api.get(`/auth/reset-password/${encodeURIComponent(token)}`);
        return {
            valid: res.data?.valid === true,
            userName: res.data?.userName || null,
            error: null,
        };
    } catch (err) {
        console.error('verifyResetToken error:', err);
        return {
            valid: false,
            userName: null,
            error: err.response?.data?.error || 'Token expirado o inválido',
        };
    }
}

export async function resetPassword(token, password) {
    try {
        const res = await api.post('/auth/reset-password', { token, password });
        return {
            success: res.data?.success === true,
            error: null,
        };
    } catch (err) {
        console.error('resetPassword error:', err);
        return {
            success: false,
            error: err.response?.data?.error || 'No se pudo actualizar la contraseña.',
        };
    }
}
